export const config = {
  EASING: [0.22, 1, 0.36, 1],
  FAST: 0.3,
  VERY_FAST: 0.2,
  DEFAULT_TRANSITION: {
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1],
  },
};
